import request from '@webtrader/core/request';

const logout = () => {
  return request.post('/api/auth/v1/logout');
};

export default logout;
